import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'allowEmailEditTillVerify',
  initialState: true,
  reducers: {
    setAllowEmailEditTillVerify(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setAllowEmailEditTillVerify } = slice.actions;

export default slice.reducer;
